import { DetailedHTMLProps, FC, HTMLAttributes } from 'react';

const CUT: FC = ({
  ...props
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
  return <div style={{ height: '100%' }}>{props.children}</div>;
};
export default CUT;
